<form odxForm [formGroup]="floorplanForm">
  <odx-form-field>
    <odx-select formControlName="activeFloorplan" odxFormFieldControl>
      @for (plan of floorplans; track plan) {
        <odx-option [value]="plan.floorplan">
          {{ getFloorplanName(plan.floorplan) }}
        </odx-option>
      }
    </odx-select>
  </odx-form-field>
</form>
